import styled from '@emotion/styled';

import { ReactComponent as ArrowIcon } from '@/assets/icons/arrow-down.svg';

export const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const DropdownValueContainer = styled.div`
  display: flex;
  align-items: center;
  min-width: 174px;
  max-width: 100%;
  height: 40px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  border: 1px solid #afafaf;
  border-radius: 4px;
  gap: 6px;
`;

export const ValueText = styled.span`
  flex: auto;
  color: black;
  font-size: 14px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SelectInput = styled.select`
  display: none;
`;

export const Arrow = styled(ArrowIcon)<{ isOpen: boolean }>`
  flex-shrink: 0;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(-180deg)' : 'rotate(0deg)')};
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  display: flex;
  flex-direction: column;
  min-width: 174px;
  max-height: 250px;
  padding: 10px 0 !important;
  overflow: auto;
  border: 1px solid #afafaf;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  gap: 10px;
`;

export const DropdownListItem = styled.li`
  display: flex;
  align-items: center;
  margin: 0 !important;
  height: 24px;
  padding: 0 8px;
  color: #000;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.light};
  }
`;
